import React from 'react'

import LoginForm from 'components/Auth/AuthForms/LoginForm'
import AuthFormWrapper from 'components/Auth/AuthFormWrapper'

const Login = () => {
    return (
        <AuthFormWrapper>
            <LoginForm />
        </AuthFormWrapper>
    )
}

export default Login
